<template>
    <div class=''>
        <template v-if="dataType">
            <v-tabs class="tabs-box" centered size="large" :value="defaultActiveKey" @change="tabsChange">
                <v-tab key="0"> {{$t('account.webAuthn.binds')}}</v-tab>
                <v-tab key="1">{{$t('account.webAuthn.unbindTab')}}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="defaultActiveKey">
                <v-tab-item :key="0">
                    <div class="tab-box">
                        <div class="bind-box">
                            <v-form
                                class="device-box mb-6"
                                ref="deviceForm">
                                <v-text-field
                                    v-model="deviceForm.deviceName"
                                    :rules="rules1"
                                    outlined
                                    hide-details="auto"
                                    required
                                    :label="$t('account.webAuthn.name')"
                                    min-height="46"
                                    dense
                                    color="#5066e0"
                                    class="code-box"
                                    :placeholder="$t('account.webAuthn.name')"
                                ></v-text-field>
                            </v-form>
                        </div>
                        <div v-if="errMsg" class="text">
                                {{errMsg}}
                        </div>
                    </div>
                    <div style="text-align: center;margin-bottom:24px;">
                        <v-btn small :color="!isSupportWebAuthn ? '' : 'primary'" :disabled="!isSupportWebAuthn" @click="bindFun">{{$t('account.bind')}}</v-btn>
                        <v-btn small outlined class="close_btn"  @click="close">{{$t('btn.close')}}</v-btn>
                    </div>
                </v-tab-item>
                <v-tab-item :key="1">
                    <v-form
                        class="device-box mb-6"
                        ref="unbindForm">
                        <v-select
                            :items="fidoList"
                            v-model="unbindFormData.tokenName"
                            :menu-props="{ bottom: true, offsetY: true }"
                            outlined
                            dense
                            class="mb-8"
                            :rules="rules.tokenName"
                            :label="$t('account.webAuthn.name')"
                            :placeholder="$t('account.webAuthn.tokenName')"
                            hide-details="auto"
                        ></v-select>

                        <v-text-field
                            v-model="dataList.mobile"
                            :value="dataList.mobile"
                            outlined
                            hide-details="auto"
                            :label="$t('account.pghoess')"
                            required
                            min-height="46"
                            dense
                            color="#5066e0"
                            class="code-box mb-8"
                            disabled
                        ></v-text-field>

                        <v-row no-gutters class="mb-8">
                            <v-col cols="7" md="7" lg="7" xl="8" sm="12">
                                <v-text-field
                                    v-model="unbindFormData.unbindCode"
                                    :rules="rules.unbindCode"
                                    outlined
                                    :label="$t('account.code')"
                                    hide-details="auto"
                                    required
                                    min-height="46"
                                    dense
                                    color="#5066e0"
                                    class="code-box"
                                    :placeholder="$t('account.codePlaceholder')"
                                ></v-text-field>
                            </v-col>
                            <v-spacer></v-spacer>

                            <v-col cols="4" md="4" lg="4" xl="3" sm="12" class="code-box ml-1 d-flex justify-end align-baseline" :class="codeText == $t('account.getCode')?'cursor-pointer':'text'" @click="getCode">
                                <v-btn small outlined v-if="codeText == $t('account.getCode')" color="primary" min-height="40" style="width:118%">{{codeText}}</v-btn>
                                <v-btn small outlined v-else style="width:100%" disabled min-height="40">{{codeText+'s'}}</v-btn>
                            </v-col>
                        </v-row>

                        <div class="text-center">
                            <v-btn small color="primary" @click="onSubmit">{{$t('btn.submit')}}</v-btn>
                            <v-btn small outlined class="close_btn" @click="close">{{$t('btn.close')}}</v-btn>
                        </div>
                    </v-form>
                </v-tab-item>
            </v-tabs-items>
        </template>
        <template v-else>
            <div class="tab-box">
                <div class="bind-box">
                    <v-form
                        class="device-box mb-6"
                        ref="deviceForm">
                        <v-text-field
                            v-model="deviceForm.deviceName"
                            :rules="rules1"
                            outlined
                            hide-details="auto"
                            required
                            :label="$t('account.webAuthn.name')"
                            min-height="46"
                            dense
                            color="#5066e0"
                            class="code-box"
                            :placeholder="$t('account.webAuthn.name')"
                        ></v-text-field>
                    </v-form>
                </div>
                <div v-if="errMsg" class="text">
                        {{errMsg}}
                </div>
            </div>
            <div style="text-align: center;margin-bottom:24px;">
                <v-btn small :color="!isSupportWebAuthn ? '' : 'primary'" :disabled="!isSupportWebAuthn" @click="bindFun">{{$t('account.bind')}}</v-btn>
                <v-btn small outlined class="close_btn"  @click="close">{{$t('btn.close')}}</v-btn>
            </div>
        </template>
    </div>
</template>

<script>

import { smsReset, webAuthnRegisterStart, webAuthnRegisterConfirm, reqU2fWindowsUnbind, reqGetU2fWindowsToken } from "@/api/index";
import { base64urlEncode, base64urlDecode } from '@/utils/base64url-arraybuffer'
import store from '@/store'

export default {

    data() {
        return {
            rules: {
                tokenName: [
                    v => !!v || this.$t('account.webAuthn.tokenName'),
                ],
                unbindCode: [
                    v => !!v || this.$t('account.codePlaceholder'),
                    v => (/^[0-9]{6}$/.test(v)) || this.$t('account.code6')

                ],
            },
            rules1: [
                v => !!v || this.$t('account.webAuthn.tokenName'),
                v => (v && v.length <= 32) || this.$t('account.webAuthn.extent')
            ],
            labelCol: { span: 8 },
            wrapperCol: { span: 14 },
            spinning: false,
            tokenList: [],
            isSupportWebAuthn:true,
            deviceForm: {},
            defaultActiveKey: "0",
            unbindFormData: {},
            errMsg:"",
            codeText: this.$t('account.getCode'),
            fidoList: []
        };
    },
    created() {
        this.getList()
        this.checkedWebAuthInfo()
    },

    props: {
        dataType: Boolean,
        dataList: Object
    },

    methods: {
        getList() {
            // this.fidoList = [
            //     {label: 'Windows Hello 人脸'},
            //     {label: 'Windows Hello 指纹'},
            // ]
            reqGetU2fWindowsToken().then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                      this.fidoList = res.data
                }else{
					store.dispatch('snackbar/openSnackbar',{
						snackbarText: res.message,
						colorType: 'error'
					})
                }
            })
        },
        onSubmit(dataName) {
            if (this.$refs.unbindForm.validate()) {
                reqU2fWindowsUnbind({
                    code: this.unbindFormData.unbindCode,
                    tokenName: this.unbindFormData.tokenName
                }).then(res=> {
                    if (res.code == this.$GLOBA.StatusOK) {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'success'
                        })
                        this.$emit("onSubmit")
                    } else {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                }).catch(err=> {
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: err.message,
                        colorType: 'error'
                    })
                })

            } else {
                return false;
            }
         },
        close() {
            this.$emit("close")
        },
        tabsChange(e) {
            if(e == 1 && !this.dataList.mobile) {
                store.dispatch('snackbar/openSnackbar',{
                    snackbarText: this.$t('account.noPhone'),
                    colorType: 'error'
                })
                this.defaultActiveKey = "0"
                return;
            }
            this.defaultActiveKey = e
        },
        getCode() {
            if(this.codeText == this.$t('account.getCode')) {
                this.spinning = true
                let params = {
                    smsType: this.$getSmsModel('unbindU2fHello')
                }
                smsReset(params).then(res=> {
                    this.spinning = false
                    if (res.code == this.$GLOBA.StatusOK) {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'success'
                        })
                        this.codeText = 60
                        let timer = setInterval(()=>{
                            this.codeText--
                            if(this.codeText <= 0) {
                                clearInterval(timer)
                                this.codeText = this.$t('account.getCode')
                            }
                        },1000)
                    }else{
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                }).catch(err=> {
                    this.spinning = false
                })
            }
        },
        checkedWebAuthInfo(){
            if(!this.detectWebAuthnSupport()){
              return
            }
            let self = this;
            if (window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable) {
              window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable().then(
                    function(result){
                        if (!result) {
                            self.errMsg = self.$t('account.webAuthn.noOpenMsg')
                            self.isSupportWebAuthn = false
                        }

                    }

                ).catch(e => {
                    self.errMsg = this.$t('account.webAuthn.noOpenMsg')
                    self.isSupportWebAuthn = false
                });
            }else{
                self.errMsg = this.$t('account.webAuthn.nonsupportMsg')
            }
        },
        detectWebAuthnSupport() {
            if (window.PublicKeyCredential === undefined ||
                typeof window.PublicKeyCredential !== "function") {
                var errorMessage = this.$t('account.webAuthn.nonsupportWebAuthn')
                if (window.location.protocol === "http:"){
                    errorMessage = this.$t('account.webAuthn.httpsMsg')
                    this.isSupportWebAuthn = false
                }
                store.dispatch('snackbar/openSnackbar',{
                    snackbarText: errorMessage,
                    colorType: 'error'
                })
                return false;
            }


            return true
        },
        bindFun() {
            let self = this
            if (this.$refs.deviceForm.validate()) {
                webAuthnRegisterStart({
                    tokenName: self.deviceForm.deviceName
                }).then(apiResponseData=> {
                    if (apiResponseData.code == self.$GLOBA.StatusOK) {
                        return new Promise(function(resolve, reject) {
                            if (apiResponseData.data.code != 0) {
                                store.dispatch('snackbar/openSnackbar',{
                                    snackbarText: apiResponseData.data.msg,
                                    colorType: 'error'
                                })
                            } else {
                                var returnInfo = {};
                                var businessData = apiResponseData.data
                                var reqid = businessData.reqid;
                                var fido2_data = businessData.fido2_data;

                                var makeCredentialOptions = {};
                                // Required apiResponseData
                                makeCredentialOptions.rp = fido2_data.rp;
                                makeCredentialOptions.user = fido2_data.user;
                                makeCredentialOptions.user.id = base64urlDecode(fido2_data.user.id);
                                makeCredentialOptions.challenge = base64urlDecode(fido2_data.challenge);
                                makeCredentialOptions.pubKeyCredParams = fido2_data.pubKeyCredParams;

                                // Optional apiResponseData
                                if ('timeout' in fido2_data) {
                                    makeCredentialOptions.timeout = fido2_data.timeout;
                                }
                                if ('excludeCredentials' in fido2_data) {
                                    makeCredentialOptions.excludeCredentials = self.credentialListConversion(fido2_data.excludeCredentials);
                                }
                                if ('authenticatorSelection' in fido2_data) {
                                    fido2_data.authenticatorSelection.userVerification = "discouraged"
                                    makeCredentialOptions.authenticatorSelection = fido2_data.authenticatorSelection;
                                }
                                if ('attestation' in fido2_data) {
                                    makeCredentialOptions.attestation = fido2_data.attestation;
                                }
                                if ('extensions' in fido2_data) {
                                    makeCredentialOptions.extensions = fido2_data.extensions;
                                }


                                // 检查浏览器是否支持函数navigator.credentials.create
                                if (typeof navigator.credentials.create !== "function") {
                                    store.dispatch('snackbar/openSnackbar',{
                                        snackbarText: self.$t('browser.errorAuthentication'),
                                        colorType: 'error'
                                    })
                                    // returnInfo.errorMsg = "Browser does not support credential creation";
                                    // resolve(returnInfo);
                                }

                                //let publicKey =
                                navigator.credentials.create({
                                    "publicKey": makeCredentialOptions
                                }).then(attestation=> {
                                    var registConfirmFido2Data = {};
                                    if ('id' in attestation) {
                                        registConfirmFido2Data.id = attestation.id;
                                    }
                                    if ('type' in attestation) {
                                        registConfirmFido2Data.type = attestation.type;
                                    }
                                    if ('rawId' in attestation) {
                                        registConfirmFido2Data.rawId = attestation.rawId;
                                    }

                                    if ('response' in attestation) {
                                        registConfirmFido2Data.response = {
                                            clientDataJSON: base64urlEncode(attestation.response.clientDataJSON),
                                            attestationObject: base64urlEncode(attestation.response.attestationObject)
                                        };

                                        registConfirmFido2Data.username = fido2_data.user.name;
                                        resolve(self.registConfirm(registConfirmFido2Data, reqid));
                                    } else {
                                        store.dispatch('snackbar/openSnackbar',{
                                            snackbarText: self.$t('account.webAuthn.windowClose'),
                                            colorType: 'error'
                                        })
                                    }
                                }).catch(function(err) {
                                    let errs = err+""
                                    if (errs.indexOf("The operation either timed out or was not allowed") > -1 || errs.indexOf("The request is not allowed by the user agent or the platform in the current context") > -1) {
                                        store.dispatch('snackbar/openSnackbar',{
                                            snackbarText: self.$t('browser.overtime'),
                                            colorType: 'error'
                                        })
                                    } else if (errs.indexOf("The user attempted to register an authenticator that contains one of the credentials already registered with the relying party") > -1 || errs.indexOf("An attempt was made to use an object that is not") > -1) {
                                        store.dispatch('snackbar/openSnackbar',{
                                            snackbarText: self.$t('account.webAuthn.repetitionBind'),
                                            colorType: 'error'
                                        })
                                    }else if (errs.indexOf("A request is already pending") > -1){
                                        store.dispatch('snackbar/openSnackbar',{
                                            snackbarText: self.$t('account.webAuthn.arouse'),
                                            colorType: 'error'
                                        })
                                    }else if (errs.indexOf("At least one credential matches an entry of the excludeCredentials list in the platform attached authenticator") > -1){
                                        //mac 会自动提示已绑定，所以有错误不提示了


                                    }else {
                                        store.dispatch('snackbar/openSnackbar',{
                                            snackbarText: "FIDO2（WebAuthn）"+self.$t('account.webAuthn.operationFail')+"（"+errs+"）",
                                            colorType: 'error'
                                        })
                                    }
                                });
                            }
                        });
                    } else {
                        if(apiResponseData.message.indexOf("设备名称已存在")){
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: self.$t('account.webAuthn.deviceExists'),
                                colorType: 'error'
                            })
                        }else{
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: apiResponseData.message,
                                colorType: 'error'
                            })
                        }

                    }
                })
            }
        },
        registConfirm(registConfirmFido2Data, reqid) {
            webAuthnRegisterConfirm({
                reqId: reqid,
                u2fData: JSON.stringify(registConfirmFido2Data)
            }).then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
					store.dispatch('snackbar/openSnackbar',{
						snackbarText: this.$t('account.webAuthn.bindSuccess'),
						colorType: 'success'
					})
                    setTimeout(()=>{
                        this.$emit("onSubmit")
                    }, 500)
                }else{
					store.dispatch('snackbar/openSnackbar',{
						snackbarText: res.message,
						colorType: 'error'
					})
                }
            })
            .catch(err=> {
                store.dispatch('snackbar/openSnackbar',{
                    snackbarText: err.message,
                    colorType: 'error'
                })
            })
        },
        credentialListConversion(list) {
            var result = [];
            for (var i = 0; i < list.length; i++) {
                var credential = {};
                credential.type = list[i].type;
                credential.id = base64urlDecode(list[i].id);
                if ('transports' in list) {
                    credential.transports = list.transports;
                }
                result.push(credential);
            }
            return result;
        }
    },
}
</script>

<style lang='scss' scoped>
.tab-box {
    // padding: 0 50px 0;
    font-size: 15px;
    .bind-box {
        margin: 0 0 15px 0;
        span {
            cursor: pointer;
        }
    }
    .text {
        color: #999;
        margin-left: 31px;
        margin-bottom: 25px;
    }
}
.list-box {
    padding-bottom: 30px;
    .list {
        display: flex;
        padding: 10px 40px;
        .text {
            flex: 1;
        }
        .btn {
            cursor: pointer;
            color: #40a9ff;
        }
    }
}


::v-deep .ant-input-group-addon {
    min-width: 93px;
    background: none;
}
.get-code {
    cursor: pointer;
    color: #5066e0;
}
.code-btn ::v-deep .ant-input {
    border-right: 0;
}
::v-deep{
    .ant-spin-container{
        // margin-top: -10px;
    }
    .ant-tabs-bar{
        border-bottom: 0;
        margin-bottom: 0;
    }
    .ant-tabs-nav-scroll{
        text-align: center;
    }
    .ant-tabs-nav .ant-tabs-tab-active{
        color: #5066e0;
        text-shadow: 0 0 0.25px currentColor;
    }
    .ant-tabs-ink-bar{
        background: #5066e0;
    }
    .ant-tabs-nav .ant-tabs-tab:hover{
        color: #5066e0;
    }
    .ant-tabs-nav-wrap {
        margin-bottom: 20px;
    }
    .ant-tabs-nav .ant-tabs-tab {
        padding-top: 0;
    }
}
.v-application.theme--light .v-tabs.tabs-box {
    box-shadow: none !important
}
.device-box {
    width: 75%;
    margin: 0 auto;
    padding-top: 20px;
}
::v-deep .row {
    align-items: start !important;
}
.close_btn{
    margin-left: 10px;
}
.code-box ::v-deep {
  .v-btn.theme--dark {
    border-color: rgba(231, 227, 252, 0.28) !important;
    .v-btn__content{
      color:rgba(231, 227, 252, 0.67);
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 480px){
    .close_btn{
        margin-left: 6px;
    }
    ::v-deep {
        .v-text-field.v-text-field--enclosed .v-text-field__details{
            padding: 0;
        }
    }
    .device-box {
        width: 78%;
    }
}
</style>
